import { render, staticRenderFns } from "./Keyword.vue?vue&type=template&id=8c89e43a&scoped=true"
import script from "./Keyword.vue?vue&type=script&lang=js"
export * from "./Keyword.vue?vue&type=script&lang=js"
import style0 from "./Keyword.vue?vue&type=style&index=0&id=8c89e43a&prod&lang=css"
import style1 from "./Keyword.vue?vue&type=style&index=1&id=8c89e43a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c89e43a",
  null
  
)

export default component.exports